import { LinkType, FinishType } from '@nerdwallet/react-apply-now';

export default ({ ctaCopy, ctaColumnTitle, showIcon }) => ({
  className: 'brokers',
  defaultSortKey: 'fixedAPR',
  reviewTarget: '_blank',
  columns: [
    {
      title: 'Lender',
      sort: {
        sortable: false,
        key: 'product.details.star-rating.value',
        order: 'desc',
      },
      content: [
        {
          type: 'image',
          config: {
            data_keys: ['details.image_source.value'],
            className: 'clearfix product-image-small',
            provider_key: 'name',
            provider_id: 'id',
            product_topic: 'Student Loans',
            link_type: LinkType.productImage,
            finish_type: FinishType.externalApplicationReferral,
            link_data_key: 'details.apply_link.value',
          },
        },
        {
          type: 'custom',
          component: 'ReviewAnnotation',
          config: {
            review_path: 'details.review_link.value',
          },
        },
        {
          type: 'stars',
          value: 'product.details.star_rating.value',
        },
      ],
    },
    {
      title: 'Fixed APR',
      className: 'highlight-column',
      sort: {
        sortable: false,
        key: 'fixedAPR',
      },
      content: [
        {
          type: 'label',
          config: {
            text: 'Fixed APR',
            className: 'column-header mobile',
          },
        },
        {
          type: 'label',
          config: {
            data_keys: [
              'details.min_fixed_apr.value',
              'details.max_fixed_apr.value',
            ],
            format: 'percentage-range',
            className: 'product-value',
            help: {
              data_keys: ['details.disclaimer.value'],
            },
          },
        },
        {
          type: 'label',
          config: {
            text: 'Fixed',
            className: 'annotation',
          },
        },
      ],
    },
    {
      title: 'Variable APR',
      className: 'align-left-mobile',
      sort: {
        sortable: false,
        key: 'variableAPR',
      },
      content: [
        {
          type: 'label',
          config: {
            text: 'Variable APR',
            className: 'column-header mobile',
          },
        },
        {
          type: 'label',
          config: {
            data_keys: [
              'details.min_variable_apr.value',
              'details.max_variable_apr.value',
            ],
            format: 'percentage-range',
            className: 'product-value',
            help: {
              data_keys: ['details.disclaimer.value'],
            },
          },
        },
        {
          type: 'label',
          config: {
            text: 'Variable',
            className: 'annotation',
          },
        },
      ],
    },
    {
      title: 'Min credit score',
      sort: {
        sortable: false,
        key: 'minCreditScore',
      },
      content: [
        {
          type: 'label',
          config: {
            text: 'Min credit score',
            className: 'column-header mobile',
          },
        },
        {
          type: 'label',
          config: {
            data_keys: ['details.display_min_fico.value'],
            className: 'product-value',
          },
        },
      ],
    },
    {
      title: ctaColumnTitle,
      className: 'cta-column',
      sort: {
        sortable: false,
        key: 'total',
      },
      content: [
        {
          type: 'label',
        },
        {
          type: 'apply',
          config: {
            data_keys: ['name', 'apply'],
            provider_key: 'name',
            link_type: LinkType.applyNowButton,
            finish_type: FinishType.externalApplicationReferral,
            provider_id: 'id',
            product_topic: 'Student Loans',
            link_data_key: 'details.apply_link.value',
            ctype: 'Offer',
            buttonText: ctaCopy,
            show_icon: showIcon,
          },
        },
      ],
    },
  ],
});
